
import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CustomLineChart from "./../components/CustomLineChart";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import UserProfile from "../../components/UserProfile";
import ArrowIcon from "./ArrowIcon";
const PropertyTypePage = (props) => {
    const {type, reportData, searchTags, summarizeGeographies,logo, currentPeriodName, customDate, user, formValues, defaultLogo } = props;
	const {  dateOptions, theme ,branding} = customDate;
    const isPos = (validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.current_period.count`
      ) &&
      validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.prior_year_period.count`
      )
        ? reportData.facets[type.key].contract_signed.current_period.count >= reportData.facets[type.key].contract_signed.prior_year_period.count
        : true);
      const chartData =  validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.chart`
      )
        ? reportData.facets[type.key].contract_signed.chart.buckets.slice(reportData.facets[type.key].contract_signed.chart.buckets.length - 13, reportData.facets[type.key].contract_signed.chart.buckets.length).map(item => ({year : formatDateRange(null, null, item.val), price: item.count ? Math.round(item.count) : 0})) : [];
        return (
          <>
            <div
              className="social-media-report-container page-section"
             
            >
              <section className="social-branding">
                {branding && branding && branding === "mylogo" && logo ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        className="header-logo"
                        src={logo}
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : branding && branding && branding === "marketproof" ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        src={defaultLogo}
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : null}
                <UserProfile formValues={formValues} user={user} />
              </section>
              <section className="social-section" >
                <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
                <div className="heading editable">{type.name}</div>
               
                <div className="sub-header-wrapper">
                 <div className="sub-header-type editable">{type.title}</div>
                 <div className="sub-header-type date editable">{currentPeriodName}</div>
                </div>
               
                
                <div className="content-wrapper">
                  <h3>{(validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.count`
                  ) &&
                  validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.prior_year_period.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.current_period.count
                      )
                    : "--")}</h3>
                  <ArrowIcon isPositive={isPos} />
                  <div className="grid-layout">
                    <div  className="row">
                      <div>YoY Chg</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.count`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.count`
                      )
                        ? `${isPos ? "+" : ""}${percentageChange(
                            reportData.facets[type.key].contract_signed.current_period
                              .count,
                            reportData.facets[type.key].contract_signed.prior_year_period
                              .count
                          )}%`
                        : "--")}</div>
                    </div>
                    <div  className="row">
                      <div>Avg Price</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.avg_price`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.avg_price`
                      )
                        ? `${_formatPrice(
                            reportData.facets[type.key].contract_signed.current_period
                              .avg_price)}`
                        : "--")}</div>
                    </div>
                    <div  className="row">
                      <div>Avg PPSF</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.ppsf.avg`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.ppsf.avg`
                      )
                        ? `$${_formatNumber(
                            reportData.facets[type.key].contract_signed.current_period
                              .ppsf.avg)}`
                        : "--")}</div>
                    </div>
                   
                  </div>
                </div>
              <div className="social-chart">
              <CustomLineChart
                  theme={theme}
                  data={chartData}
                  isWeekly={dateOptions.gap}
                />
              </div>
              </section>
            </div>
          </>
        );
}


export default PropertyTypePage